import { useEffect } from 'react';
import { PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetCorporateDeliveryChannelValidatorsQuery,
  useLazyGetCorporateDeliveryChannelsQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import DeliveryChannelsList from '../../partial/delivery-channels/list';

const CorporateDeliveryChannels = (): React.JSX.Element => {
  const [getValidators] = useLazyGetCorporateDeliveryChannelValidatorsQuery();

  const {
    amlDictionaries: { activePermissions },
    corporateClientsRisk: {
      deliveryChannels: {
        list: { values, pagination, errorsList },
      },
    },
  } = useAppSelector((state) => state);

  const [getCorporateDeliveryChannels, { isLoading, isFetching }] =
    useLazyGetCorporateDeliveryChannelsQuery();

  useEffect(() => {
    if (
      activePermissions?.includes(
        PermissionEnum.SETTINGS_DELIVERY_CHANNELS_LIST,
      )
    ) {
      getValidators();
    }
  }, [activePermissions]);

  useEffect(() => {
    let title = 'Corporate Delivery channels';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <DeliveryChannelsList
      values={values}
      pagination={pagination}
      getList={getCorporateDeliveryChannels}
      isFetching={isFetching}
      clientType={RiskScoreClientTypeEnum.CORPORATE}
      isLoading={isLoading}
      errorsList={errorsList}
    />
  );
};

export default CorporateDeliveryChannels;
